<template>
  <div>
    <b-col sm="6" class="component-margin">
      <b-row>
        <b-col sm="6">
          <b-input size="sm" v-model="filter" placeholder="検索する"/>
        </b-col>
        <b-col sm="6">
          <b-button size="sm" @click="editModal(null, false)" variant="danger">新しい商品を登録する</b-button>
        </b-col>
      </b-row>
    </b-col>
    <b-col sm="12">
        <b-table show-empty stacked=md bordered=true striped=true small=true hover=true
                :items="filteredItems" :fields="fields"
                :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection">
        <template slot="imageUrl" slot-scope="row">
          <b-img center width="50" height="50" :src="row.value"/>
        </template>
        <template slot="update" slot-scope="row">
          <b-button size="sm" :disabled="row.item['registeredSet']" @click="editModal(row, false)" variant="warning">更新</b-button>
        </template>
        <template slot="delete" slot-scope="row">
          <b-button size="sm" :disabled="row.item['registeredSet']" @click="deleteRowConfirm(row)" variant="secondary">削除</b-button>
        </template>
        <template slot="add" slot-scope="row">
          <b-button size="sm" :disabled="row.item['registeredSet']" @click="editModal(row, true)" variant="primary">追加</b-button>
        </template>
      </b-table>
      <b-modal ref="editModal" title="セット商品登録" @ok="handleOk">
        <b-form-group size="sm" label-cols-sm="3" label-align-sm="right" label="[親]ASIN" label-for="asin">
          <b-form-input size="sm" :disabled="addChild || isUpdate" id="asin" v-model="editItem.asin" type="text"/>
        </b-form-group>
        <b-form-group size="sm" label-cols-sm="3" label-align-sm="right" label="[子]商品コード" label-for="childJanCode">
          <b-form-input size="sm" id="childJanCode" v-model="editItem.childJanCode" type="text"/>
        </b-form-group>
        <b-form-group size="sm" label-cols-sm="3" label-align-sm="right" label="[子]商品名(日)" label-for="childProductNameJp">
          <b-form-input size="sm" id="childProductNameJp" v-model="editItem.childProductNameJp" type="text"/>
        </b-form-group>
        <b-form-group size="sm" label-cols-sm="3" label-align-sm="right" label="必要数" label-for="purchaseQuantity">
          <b-form-input size="sm" id="purchaseQuantity" v-model="editItem.purchaseQuantity" type="text"/>
        </b-form-group>
        <b-form-group size="sm" label-cols-sm="3" label-align-sm="right" label="備考" label-for="remark">
          <b-form-input size="sm" id="remark" v-model="editItem.remark" type="text"/>
        </b-form-group>
      </b-modal>
    </b-col>
    <!-- <b-col md="6">
      <b-pagination :total-rows="totalRows" :per-page="perPage" v-model="currentPage"/>
    </b-col> -->
    <b-modal ref="deleteRowConfirm" @ok="deleteRow" hide-header>
      <div class="text-center">{{confirmMessage}}</div>
    </b-modal>
    <b-modal ref="confirmMessage" ok-only hide-header>
      <div class="text-center"><label>{{confirmMessage}}</label></div>
    </b-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import BaseComponent from '@/components/BaseComponent';
import * as api from '@/api';

export default {
  mixins: [BaseComponent],
  data() {
    return {
      items: [],
      fields: [
        { key: 'imageUrl', label: '画像', sortable: true, variant: 'base', class: 'table-cw5' },
        { key: 'asin', label: '[親]ASIN', sortable: true, variant: 'base', class: 'table-lw8' },
        { key: 'productNameEn', label: '[親]商品名(英)', sortable: true, variant: 'base' },
        { key: 'childJanCode', label: '[子]商品コード', sortable: true, variant: 'base', class: 'table-lw9' },
        { key: 'childProductNameJp', label: '[子]商品名(日)', sortable: true, variant: 'base' },
        { key: 'purchaseQuantity', label: '必要数', sortable: true, variant: 'base', class: 'table-right table-rw5' },
        { key: 'remark', label: '備考', sortable: true, variant: 'base' },
        { key: 'update', label: '更新', variant: 'success', class: 'table-cw4' },
        { key: 'delete', label: '削除', variant: 'success', class: 'table-cw4' },
        { key: 'add', label: '追加', variant: 'success', class: 'table-cw4' },
      ],
      // currentPage: 1,
      // perPage: 25,
      totalRows: 0,
      filter: '',
      sortBy: null,
      sortDesc: false,
      sortDirection: 'asc',
      addChild: false,
      editItem: {},
      isUpdate: false,
      confirmMessage: '',
      isDisabled: true,
      isRegistered: false,
    };
  },
  created() {
    api.getItemSetRegistration((items) => {
      this.items = items;
      this.totalRows = this.items.length;
    });
  },
  computed: {
    filteredItems() {
        let filteredItems = this.items.filter(item => {
         return (this.filter === '' ||
                 ((item.asin !== null && item.asin.indexOf(this.filter) !== -1) ||
                  (item.productNameEn !== null && item.productNameEn.indexOf(this.filter) !== -1) ||
                  (item.childJanCode !== null && item.childJanCode.indexOf(this.filter) !== -1) ||
                  (item.childProductNameJp !== null && item.childProductNameJp.indexOf(this.filter) !== -1)
                 ));
        });
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
      return filteredItems;
    },
  },
  methods: {
    editModal(row, isAdd) {
      // 新規(null, false) or 更新(notnull, false) or 追加(notnull, true)
      this.editItem = {};
      this.isUpdate = false;
      this.addChild = false;
      if (row !== null) {
        // 更新or追加
        this.isUpdate = true;
        // Object.assign(this.editItem, row.item);
        this.editItem =  Object.assign({}, this.editItem , row.item);
        if (isAdd === true) {
          // 追加
          this.isUpdate = false;
          this.addChild = true;
          this.editItem.childJanCode = '';
          this.editItem.purchaseQuantity = '';
          this.editItem.childProductNameJp = '';
          this.editItem.remark = '';
        }
      }
      this.$refs.editModal.show();
    },
    handleOk() {
      if (this.isUpdate) {
        api.updateItemSetRegistration(this.editItem, (items) => {
          this.items = items;
          this.totalRows = this.items.length;
          this.confirmMessage = '更新完了しました。';
          this.$refs.confirmMessage.show();
        });
      } else {
        api.registerItemSetRegistration(this.editItem, (items) => {
          this.items = items;
          this.totalRows = this.items.length;
          this.confirmMessage = '登録完了しました。';
          this.$refs.confirmMessage.show();
        });
      }
    },
    deleteRowConfirm(row) {
      this.editItem = row.item;
      this.confirmMessage = '削除しますか？';
      this.$refs.deleteRowConfirm.show();
    },
    deleteRow() {
      api.deleteItemSetRegistration(this.editItem, (items) => {
        this.items = items;
        this.totalRows = this.items.length;
      });
    },
  },
};

</script>

<style scoped>
.component-margin {
  margin-bottom: 1rem;
}

@media (min-width: 768px) {
  .table-right { text-align: right; }
  .table-cw4  { min-width:  4rem; max-width:  4rem; width:  4rem; text-align:center; }
}
</style>

